import { UnauthenticatedAccessAttemptNotification } from "%notifications";
import { pushNotification } from "%error/utils";

export default {
  supports(code) {
    return code === 401;
  },

  handle() {
    pushNotification(UnauthenticatedAccessAttemptNotification);
  }
};
